/* Imperial — Tae's Imperial Gold theme
   - renders the grillz illustrations ([data-tig-grillz], [data-tig-cut])
   - runs the configurator ([data-tig-configurator]) against real product variants
   - adds to cart through /cart/add.js, updates [data-cart-count]
   - FAQ accordion ([data-tig-faq]) */
(function () {
  'use strict';
  window.TIG = window.TIG || {};
  var T = window.TIG;

  /* ---------- grillz illustration ---------- */
  var FIN = {
    w: { line: '#3a3a3a', dark: '#2a2a2a', stops: ['#ffffff', '#e9e9e9', '#bcbcbc', '#858585', '#d6d6d6'] },
    y: { line: '#3b2d0c', dark: '#2b2110', stops: ['#fff4bf', '#f2d262', '#c9a227', '#9c7716', '#e6c552'] },
    r: { line: '#5a3528', dark: '#3a2219', stops: ['#ffe6d6', '#f0bfa3', '#d3977a', '#9e6448', '#e8b391'] }
  };
  var OFFS = [0, 0.28, 0.55, 0.8, 1];
  var uid = 0;

  function r1(n) { return (Math.round(n * 10) / 10).toString(); }
  function rr(x, y, w, h, rt, rb) {
    rt = Math.min(rt, w / 2, h / 2); rb = Math.min(rb, w / 2, h / 2);
    return 'M' + r1(x + rt) + ' ' + r1(y) + 'H' + r1(x + w - rt) + 'Q' + r1(x + w) + ' ' + r1(y) + ' ' + r1(x + w) + ' ' + r1(y + rt) +
      'V' + r1(y + h - rb) + 'Q' + r1(x + w) + ' ' + r1(y + h) + ' ' + r1(x + w - rb) + ' ' + r1(y + h) + 'H' + r1(x + rb) +
      'Q' + r1(x) + ' ' + r1(y + h) + ' ' + r1(x) + ' ' + r1(y + h - rb) + 'V' + r1(y + rt) + 'Q' + r1(x) + ' ' + r1(y) + ' ' + r1(x + rt) + ' ' + r1(y) + 'Z';
  }
  function row(n, u, cx, yGum, hMax, bottom) {
    var PAT = [1, 0.86, 0.82, 0.74, 0.7], half = n / 2, ws = [], i;
    for (i = half - 1; i >= 0; i--) ws.push(PAT[i]);
    for (i = 0; i < half; i++) ws.push(PAT[i]);
    var gap = 0.08 * u, W = 0;
    for (i = 0; i < ws.length; i++) W += ws[i] * u;
    W += gap * (n - 1);
    var x = cx - W / 2, teeth = [], cuts = [], shine = [];
    ws.forEach(function (wu) {
      var w = wu * u, h = hMax * (0.72 + 0.28 * wu), y = bottom ? yGum - h : yGum;
      var rG = Math.max(5, w * 0.09), rE = w * 0.36;
      teeth.push(bottom ? rr(x, y, w, h, rE, rG) : rr(x, y, w, h, rG, rE));
      var cy = bottom ? yGum - 0.13 * hMax : yGum + 0.13 * hMax, b = bottom ? -0.07 * hMax : 0.07 * hMax;
      cuts.push('M' + (x + 5).toFixed(1) + ' ' + cy.toFixed(1) + 'Q' + (x + w / 2).toFixed(1) + ' ' + (cy + b).toFixed(1) + ' ' + (x + w - 5).toFixed(1) + ' ' + cy.toFixed(1));
      var sy = bottom ? y + 0.09 * h : y + 0.19 * h;
      shine.push(rr(x + w * 0.15, sy, w * 0.16, h * 0.66, w * 0.08, w * 0.08));
      x += w + gap;
    });
    return { teeth: teeth, cuts: cuts, shine: shine };
  }
  function grill(top, bottom, u) {
    var t = [], c = [], s = [], f = 1 + (10 - Math.max(top, bottom)) * 0.04;
    var add = function (rw) { t = t.concat(rw.teeth); c = c.concat(rw.cuts); s = s.concat(rw.shine); };
    if (top && bottom) { add(row(top, u * f, 300, 62, 150, false)); add(row(bottom, u * f * 0.94, 300, 358, 138, true)); }
    else if (top) { add(row(top, u * 1.15 * f, 300, 128, 172 * Math.sqrt(f), false)); }
    else if (bottom) { add(row(bottom, u * 1.1 * f, 300, 292, 160 * Math.sqrt(f), true)); }
    return { teeth: t.join(''), cuts: c.join(''), shine: s.join('') };
  }
  function svg(paths, finish, o) {
    o = o || {};
    var f = FIN[finish] || FIN.w, id = 'tig-g' + (++uid);
    var stops = f.stops.map(function (c, i) { return '<stop offset="' + OFFS[i] + '" stop-color="' + c + '"></stop>'; }).join('');
    var label = o.label ? ' role="img" aria-label="' + String(o.label).replace(/"/g, '&quot;') + '"' : ' aria-hidden="true"';
    return '<svg viewBox="0 0 600 ' + (o.h || 420) + '"' + label + '><defs><linearGradient id="' + id + '" x1="0" y1="0" x2="0" y2="1">' + stops + '</linearGradient></defs>' +
      '<path d="' + paths.teeth + '" fill="' + f.dark + '" stroke="' + f.dark + '" stroke-width="' + (o.stroke || 9) + '" stroke-linejoin="round"></path>' +
      '<path d="' + paths.teeth + '" fill="url(#' + id + ')"></path>' +
      '<path d="' + paths.cuts + '" fill="none" stroke="' + f.line + '" stroke-width="' + (o.cut || 3) + '" stroke-linecap="round" opacity="0.7"></path>' +
      '<path d="' + paths.shine + '" fill="#ffffff" opacity="0.32"></path>' + (o.extra || '') + '</svg>';
  }
  function finishKey(v) {
    v = String(v || '').toLowerCase();
    if (v === 'y' || v.indexOf('yellow') > -1) return 'y';
    if (v === 'r' || v.indexOf('rose') > -1) return 'r';
    return 'w';
  }
  function teethNum(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  function renderGrillz(el) {
    var top = teethNum(el.getAttribute('data-top')), bottom = teethNum(el.getAttribute('data-bottom'));
    var finish = finishKey(el.getAttribute('data-finish')), u = +el.getAttribute('data-u') || 52;
    if (!top && !bottom) { el.innerHTML = ''; return; }
    el.innerHTML = svg(grill(top, bottom, u), finish, { label: el.getAttribute('data-label') || '', stroke: +el.getAttribute('data-stroke') || 9 });
  }
  function renderCut(el) {
    var r = row(2, 170, 300, 36, 290, false);
    var gold = el.getAttribute('data-gold') || '#d4af37';
    var extra = '<line x1="300" y1="14" x2="300" y2="350" stroke="' + gold + '" stroke-width="1.5" stroke-dasharray="4 7"></line>' +
      '<text x="312" y="28" fill="' + gold + '" font-size="11" letter-spacing="2.5" font-family="Archivo, Helvetica, sans-serif">' + (el.getAttribute('data-caption') || 'THE CUT') + '</text>';
    el.innerHTML = svg({ teeth: r.teeth.join(''), cuts: r.cuts.join(''), shine: r.shine.join('') }, finishKey(el.getAttribute('data-finish')), { h: 360, stroke: 14, cut: 5, label: el.getAttribute('data-label') || '', extra: extra });
  }

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    var n = cents / 100, whole = Math.round(cents) % 100 === 0;
    var fixed = n.toFixed(2), intPart = Math.round(whole ? n : Math.floor(n)).toString();
    var grp = function (s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var grpDot = function (s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
    var out = fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grpDot(Math.round(n).toString()))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, grpDot(fixed.split('.')[0]) + (whole ? '' : ',' + fixed.split('.')[1]))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, grp(Math.round(n).toString()))
      .replace(/\{\{\s*amount\s*\}\}/, grp(fixed.split('.')[0]) + (whole ? '' : '.' + fixed.split('.')[1]));
    return out.replace(/<[^>]*>/g, '');
  }
  T.money = money;

  /* ---------- configurator ---------- */
  function initConfigurator(root) {
    if (root.__tig) return;
    root.__tig = true;
    var dataEl = root.querySelector('[data-tig-product]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var options = data.options || [], variants = data.variants || [];
    var kitEl = root.querySelector('[data-tig-kit]'), kit = null;
    if (kitEl) { try { kit = JSON.parse(kitEl.textContent); } catch (e) { kit = null; } }
    if (kit && !kit.id) kit = null;

    var lower = options.map(function (o) { return String(o).toLowerCase(); });
    var idxFinish = lower.findIndex(function (o) { return /finish|color|colour|material|metal/.test(o); });
    var idxTop = lower.findIndex(function (o) { return /top/.test(o); });
    var idxBottom = lower.findIndex(function (o) { return /bottom/.test(o); });

    var avail = variants.filter(function (v) { return v.available; });
    // default: 6 top, no bottom, first finish — when such a variant exists; else first available
    var preferred = avail.filter(function (v) {
      var t = idxTop > -1 ? teethNum(v['option' + (idxTop + 1)]) : 0, b = idxBottom > -1 ? teethNum(v['option' + (idxBottom + 1)]) : 0;
      return t === 6 && b === 0;
    })[0];
    var first = preferred || avail[0] || variants[0];
    var selected = options.map(function (_, i) { return first ? first['option' + (i + 1)] : null; });
    // extra choices that ride along as line-item properties (e.g. Initial), not variants
    var props = {};
    root.querySelectorAll('[data-prop-group]').forEach(function (g) {
      var f = g.querySelector('[data-prop-value]'); if (f) props[g.getAttribute('data-prop-group')] = f.getAttribute('data-prop-value');
    });
    var useKit = !!kit && root.getAttribute('data-kit-default') !== 'false';
    var added = '';

    var $ = function (sel) { return root.querySelector(sel); };
    var preview = $('[data-cfg-preview]'), empty = $('[data-cfg-empty]'), stageMeta = $('[data-cfg-stage-meta]'), photo = $('[data-cfg-photo]');
    var photosEl = $('[data-tig-photos]'), photos = {};
    if (photosEl) { try { photos = JSON.parse(photosEl.textContent); } catch (e) { photos = {}; } }
    var prevBtn = $('[data-cfg-prev]'), nextBtn = $('[data-cfg-next]'), counter = $('[data-cfg-counter]'), thumbs = $('[data-cfg-thumbs]');
    var view = 0, lastFin = null, thumbsKey = '';
    function renderThumbs(list) {
      if (!thumbs) return;
      var key = list.join('|');
      if (key !== thumbsKey) {
        thumbsKey = key;
        thumbs.innerHTML = '';
        list.forEach(function (src, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'tig-cfg__thumb'; b.setAttribute('data-cfg-thumb', String(i)); b.setAttribute('aria-label', 'View ' + (i + 1));
          var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; im.className = 'tig-photo';
          b.appendChild(im); thumbs.appendChild(b);
        });
      }
      thumbs.hidden = list.length < 2;
      thumbs.querySelectorAll('[data-cfg-thumb]').forEach(function (b, i) { b.setAttribute('aria-pressed', i === view ? 'true' : 'false'); });
    }
    function photoList(c) {
      var l = (photos[c.fin] || []).slice();
      if (!l.length) l = (photos.w || photos.y || photos.r || []).slice();
      if (c.v && c.v.image && l.indexOf(c.v.image) === -1) l.unshift(c.v.image);
      return l.filter(Boolean);
    }
    var caption = $('[data-cfg-teeth]'), priceEl = $('[data-cfg-price]'), breakEl = $('[data-cfg-breakdown]');
    var btn = $('[data-cfg-add]'), btnLabel = $('[data-cfg-add-label]'), addedEl = $('[data-cfg-added]'), addedText = $('[data-cfg-added-text]');
    var kitLabel = $('[data-cfg-kit-current]');
    var minTeeth = +root.getAttribute('data-min-teeth') || 0;

    function match(sel) {
      return variants.find(function (v) {
        for (var i = 0; i < options.length; i++) { if (v['option' + (i + 1)] !== sel[i]) return false; }
        return true;
      });
    }
    function existsWith(i, value) {
      var s = selected.slice(); s[i] = value; return !!match(s);
    }
    function current() {
      var top = idxTop > -1 ? teethNum(selected[idxTop]) : 0;
      var bottom = idxBottom > -1 ? teethNum(selected[idxBottom]) : 0;
      var fin = idxFinish > -1 ? finishKey(selected[idxFinish]) : 'w';
      return { top: top, bottom: bottom, fin: fin, v: match(selected) };
    }
    function teethLabel(c) {
      if (idxTop === -1 && idxBottom === -1) {
        // no teeth options (e.g. Finish × Initial): describe the other choices instead
        var pre = Object.keys(props).map(function (k) { return k + ' ' + props[k]; });
        return pre.concat(options.map(function (o, i) {
          if (i === idxFinish) return '';
          var val = selected[i] || '';
          // "8 Teeth" already names its option; "Bottom" under "Jaw" doesn't
          return String(val).toLowerCase().indexOf(String(o).toLowerCase()) > -1 ? val : o + ' ' + val;
        })).filter(Boolean).join(' · ') || (root.getAttribute('data-label-piece') || '');
      }
      if (!c.top && !c.bottom) return root.getAttribute('data-label-none') || 'No teeth selected';
      return (c.top ? c.top + ' top' : '') + (c.top && c.bottom ? ' · ' : '') + (c.bottom ? c.bottom + ' bottom' : '');
    }
    function update() {
      var c = current();
      // pills
      root.querySelectorAll('[data-option-index]').forEach(function (b) {
        var i = +b.getAttribute('data-option-index'), val = b.getAttribute('data-value');
        b.setAttribute('aria-pressed', selected[i] === val ? 'true' : 'false');
        b.classList.toggle('is-unavailable', !existsWith(i, val));
      });
      root.querySelectorAll('[data-prop-value]').forEach(function (b) {
        var g = b.closest('[data-prop-group]'); b.setAttribute('aria-pressed', g && props[g.getAttribute('data-prop-group')] === b.getAttribute('data-prop-value') ? 'true' : 'false');
      });
      root.querySelectorAll('[data-prop-current]').forEach(function (s) { s.textContent = props[s.getAttribute('data-prop-current')] || ''; });
      root.querySelectorAll('[data-option-current]').forEach(function (s) {
        var i = +s.getAttribute('data-option-current'); s.textContent = selected[i] || '';
      });
      root.querySelectorAll('[data-kit]').forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-kit') === '1') === useKit ? 'true' : 'false'); });
      if (kitLabel) kitLabel.textContent = useKit ? (root.getAttribute('data-label-kit') || 'Mold kit') : (root.getAttribute('data-label-own') || 'Own molds');
      // preview: a photo when we have one for this finish (variant image first), else the drawn set
      var hasTeeth = (idxTop === -1 && idxBottom === -1) || c.top || c.bottom;
      if (c.fin !== lastFin) { view = 0; lastFin = c.fin; }
      var pl = photoList(c), src = '';
      if (pl.length) { view = ((view % pl.length) + pl.length) % pl.length; src = pl[view]; }
      if (photo && src) {
        if (photo.getAttribute('src') !== src) photo.setAttribute('src', src);
        photo.hidden = false;
        if (preview) { preview.innerHTML = ''; preview.hidden = true; }
        if (empty) empty.hidden = true;
        var many = pl.length > 1;
        if (prevBtn) prevBtn.hidden = !many;
        if (nextBtn) nextBtn.hidden = !many;
        if (counter) { counter.hidden = !many; counter.textContent = (view + 1) + ' / ' + pl.length; }
        renderThumbs(pl);
      } else {
        if (photo) photo.hidden = true;
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        if (counter) counter.hidden = true;
        if (thumbs) thumbs.hidden = true;
        if (preview) {
          if (hasTeeth) {
            var paths = grill(c.top || (idxTop === -1 && idxBottom === -1 ? 6 : 0), c.bottom, 52);
            preview.innerHTML = svg(paths, c.fin, { label: 'Preview of your set' });
            preview.hidden = false;
          } else { preview.innerHTML = ''; preview.hidden = true; }
        }
        if (empty) empty.hidden = !!hasTeeth;
      }
      if (stageMeta) stageMeta.textContent = idxFinish > -1 ? (selected[idxFinish] || '') : '';
      if (caption) caption.textContent = teethLabel(c);
      // price
      var ok = !!c.v && c.v.available && (c.top + c.bottom >= minTeeth || (idxTop === -1 && idxBottom === -1));
      var total = ok ? c.v.price + (useKit && kit ? kit.price : 0) : 0;
      if (priceEl) priceEl.textContent = ok ? money(total) : '—';
      if (breakEl) {
        if (ok) {
          var parts = [money(c.v.price) + ' ' + (root.getAttribute('data-label-set') || 'set')];
          if (useKit && kit) parts.push((root.getAttribute('data-label-kit') || 'Mold kit').toLowerCase() + ' ' + money(kit.price));
          breakEl.textContent = parts.join(' + ') + ' · ' + (root.getAttribute('data-label-shipping') || 'Shipping calculated at checkout');
        } else if (!c.v) {
          breakEl.textContent = root.getAttribute('data-label-nocombo') || 'This combination is not available.';
        } else if (!c.v.available) {
          breakEl.textContent = root.getAttribute('data-label-soldout') || 'Sold out.';
        } else {
          breakEl.textContent = (root.getAttribute('data-label-min') || 'Select at least {n} teeth to price your set.').replace('{n}', minTeeth);
        }
      }
      if (btn && T.catalog) {
        btn.disabled = true; btn.classList.add('is-off');
        if (btnLabel) btnLabel.textContent = (T.strings && T.strings.catalog) || 'Coming soon';
      } else if (btn) {
        btn.disabled = !ok; btn.classList.toggle('is-off', !ok);
        if (btnLabel) btnLabel.textContent = ok ? (T.strings && T.strings.add || 'Add to cart') + ' — ' + money(total) : (T.strings && T.strings.unavailable || 'Unavailable');
      }
      if (addedEl) { addedEl.hidden = !added; if (addedText) addedText.textContent = added; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); view -= 1; update(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); view += 1; update(); });
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cfg-thumb]'); if (!t) return;
      e.preventDefault(); view = +t.getAttribute('data-cfg-thumb') || 0; update();
    });
    root.addEventListener('click', function (e) {
      var pp = e.target.closest('[data-prop-value]');
      if (pp && root.contains(pp)) { props[pp.closest('[data-prop-group]').getAttribute('data-prop-group')] = pp.getAttribute('data-prop-value'); added = ''; update(); return; }
      var b = e.target.closest('[data-option-index]');
      if (b && root.contains(b)) { selected[+b.getAttribute('data-option-index')] = b.getAttribute('data-value'); added = ''; update(); return; }
      var k = e.target.closest('[data-kit]');
      if (k && root.contains(k)) { useKit = k.getAttribute('data-kit') === '1'; added = ''; update(); return; }
    });

    if (btn) btn.addEventListener('click', function () {
      var c = current();
      if (T.catalog || !c.v || btn.disabled) return;
      var line = { id: c.v.id, quantity: 1 };
      if (Object.keys(props).length) line.properties = props;
      var items = [line];
      if (useKit && kit) items.push({ id: kit.id, quantity: 1 });
      btn.disabled = true;
      fetch((T.routes && T.routes.cartAdd) || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          var fin = idxFinish > -1 ? selected[idxFinish] : '';
          added = [fin, teethLabel(c)].filter(Boolean).join(' — ') + (useKit && kit ? ' + ' + (root.getAttribute('data-label-kit') || 'Mold kit').toLowerCase() : '');
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          });
        })
        .catch(function () { added = root.getAttribute('data-label-error') || 'Could not add to cart. Please try again.'; })
        .then(function () { update(); });
    });

    update();
  }

  /* ---------- collection tile: finish swatches swap the photo ---------- */
  function initTile(root) {
    if (root.__tig) return; root.__tig = true;
    var img = root.querySelector('[data-tile-photo]'), drawn = root.querySelector('[data-tig-grillz]'), label = root.querySelector('[data-tile-finish]');
    var swatches = root.querySelectorAll('[data-tile-swatch]');
    function set(btn) {
      var k = btn.getAttribute('data-tile-swatch');
      if (img) { var src = img.getAttribute('data-src-' + k); if (src) img.setAttribute('src', src); }
      if (drawn) { drawn.setAttribute('data-finish', k); renderGrillz(drawn); }
      if (label) label.textContent = btn.getAttribute('data-finish-name') || '';
      swatches.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    }
    swatches.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); set(b); });
      b.addEventListener('mouseenter', function () { set(b); });
      b.addEventListener('focus', function () { set(b); });
    });
  }

  /* ---------- Shop All card: swatches switch finish, arrows cycle views, bookmark saves locally ---------- */
  var SAVED_KEY = 'tig-saved';
  function readSaved() { try { return JSON.parse(localStorage.getItem(SAVED_KEY) || '[]'); } catch (e) { return []; } }
  function writeSaved(list) { try { localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) {} }
  function initCard(root) {
    if (root.__tig) return; root.__tig = true;
    var data = {}; try { data = JSON.parse(root.getAttribute('data-images') || '{}'); } catch (e) { data = {}; }
    var fin = root.getAttribute('data-finish') || 'w', view = 0;
    var img = root.querySelector('[data-card-img]'), drawn = root.querySelector('[data-tig-grillz]');
    var prev = root.querySelector('[data-card-prev]'), next = root.querySelector('[data-card-next]'), save = root.querySelector('[data-card-save]');
    var url = root.getAttribute('data-url') || '';
    function list() { var l = data[fin]; if (!l || !l.length) l = data.w || data.y || data.r || []; return l.filter(Boolean); }
    function show() {
      var l = list();
      if (img && l.length) {
        view = ((view % l.length) + l.length) % l.length;
        if (img.getAttribute('src') !== l[view]) img.setAttribute('src', l[view]);
      }
      if (drawn) { drawn.setAttribute('data-finish', fin); renderGrillz(drawn); }
      root.querySelectorAll('[data-card-finish]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-card-finish') === fin ? 'true' : 'false'); });
      var many = l.length > 1;
      if (prev) prev.hidden = !many; if (next) next.hidden = !many;
    }
    root.querySelectorAll('[data-card-finish]').forEach(function (b) {
      var pick = function () { fin = b.getAttribute('data-card-finish'); view = 0; show(); };
      b.addEventListener('click', function (e) { e.preventDefault(); pick(); });
      b.addEventListener('mouseenter', pick);
    });
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); view -= 1; show(); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); view += 1; show(); });
    if (save) {
      var saved = readSaved();
      save.setAttribute('aria-pressed', url && saved.indexOf(url) > -1 ? 'true' : 'false');
      save.addEventListener('click', function (e) {
        e.preventDefault();
        var s = readSaved(), i = s.indexOf(url);
        if (i > -1) s.splice(i, 1); else if (url) s.push(url);
        writeSaved(s);
        save.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      });
    }
    show();
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    if (root.__tig) return; root.__tig = true;
    root.addEventListener('click', function (e) {
      var q = e.target.closest('.tig-faq__q'); if (!q) return;
      var open = q.getAttribute('aria-expanded') === 'true';
      root.querySelectorAll('.tig-faq__q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.querySelector('i').textContent = '+'; var a = document.getElementById(b.getAttribute('aria-controls')); if (a) a.hidden = true; });
      if (!open) { q.setAttribute('aria-expanded', 'true'); q.querySelector('i').textContent = '−'; var a2 = document.getElementById(q.getAttribute('aria-controls')); if (a2) a2.hidden = false; }
    });
  }

  /* ---------- About us video ---------- */
  function initVideo(root) {
    if (root.__tig) return; root.__tig = true;
    var v = root.querySelector('video'); if (!v) return;
    var soundBtn = root.querySelector('[data-video-sound]'), playBtn = root.querySelector('[data-video-play]');
    var label = root.querySelector('[data-video-sound-label]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var userPaused = false, heard = false;
    v.muted = true;
    function sync() {
      root.classList.toggle('is-playing', !v.paused && !v.ended);
      root.classList.toggle('is-muted', v.muted);
      if (soundBtn) soundBtn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      if (label) label.textContent = v.muted ? 'Sound on' : 'Sound off';
      if (playBtn) playBtn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    }
    ['play', 'playing', 'pause', 'ended', 'volumechange'].forEach(function (ev) { v.addEventListener(ev, sync); });
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () { sync(); }); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.35) { if (!userPaused && (!reduce || heard)) play(); }
          else if (!v.paused) v.pause();
        });
      }, { threshold: [0, 0.35, 0.7] }).observe(root);
    }
    function toggle() { if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); } }
    if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    v.addEventListener('click', toggle);
    if (soundBtn) soundBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (v.muted) {
        v.muted = false;
        if (!heard) { heard = true; try { v.currentTime = 0; } catch (err) {} }
        userPaused = false; play();
      } else { v.muted = true; }
      sync();
    });
    sync();
  }

  /* ---------- phone menu: full-screen drawer with dropdown items ---------- */
  function initMenu() {
    if (document.__tigMenu) return; document.__tigMenu = true;
    function drawer() { return document.querySelector('[data-tig-drawer]'); }
    function setOpen(open) {
      var d = drawer(); if (!d) return;
      d.hidden = !open;
      document.body.classList.toggle('tig-menu-open', open);
      document.querySelectorAll('[data-tig-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) { var c = d.querySelector('[data-tig-menu-close]'); if (c) c.focus(); }
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-tig-menu-open]')) { e.preventDefault(); setOpen(true); return; }
      if (e.target.closest('[data-tig-menu-close]')) { e.preventDefault(); setOpen(false); return; }
      var t = e.target.closest('.tig-drawer__toggle');
      if (t) {
        var sub = t.nextElementSibling, on = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (sub) sub.hidden = !on;
        return;
      }
      if (e.target.closest('[data-tig-drawer] a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 900) setOpen(false); });
  }

  /* ---------- boot ---------- */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tig-grillz]').forEach(renderGrillz);
    scope.querySelectorAll('[data-tig-cut]').forEach(renderCut);
    scope.querySelectorAll('[data-tig-configurator]').forEach(initConfigurator);
    scope.querySelectorAll('[data-tig-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-tig-tile]').forEach(initTile);
    scope.querySelectorAll('[data-tig-card]').forEach(initCard);
    scope.querySelectorAll('[data-tig-video]').forEach(initVideo);
    initMenu();
  }
  T.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
